import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
import { IconSize } from '@foundation/Icon/IconSize';

import IconHashtag12 from './IconHashtag12';
import IconHashtag16 from './IconHashtag16';
import IconHashtag20 from './IconHashtag20';
import IconHashtag24 from './IconHashtag24';
import IconHashtag32 from './IconHashtag32';

/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
const IconHashtag = (props: GeneratedIconProps): ReactElement<GeneratedIconProps> => {
    const size = props.size || IconSize.Size16;
    return (
        <span>
            {size === IconSize.Size12 && !props.filled && <IconHashtag12 {...props} />}
            {size === IconSize.Size16 && !props.filled && <IconHashtag16 {...props} />}
            {size === IconSize.Size20 && !props.filled && <IconHashtag20 {...props} />}
            {size === IconSize.Size24 && !props.filled && <IconHashtag24 {...props} />}
            {size === IconSize.Size32 && !props.filled && <IconHashtag32 {...props} />}
        </span>
    );
};
IconHashtag.displayName = 'FondueIconHashtag';

export default memo(IconHashtag);
